// extracted by mini-css-extract-plugin
export var section = "ContactForm-module--section--380PN";
export var formContainer = "ContactForm-module--form-container--3VGcD";
export var inputContainer = "ContactForm-module--input-container--2Spx3";
export var button = "ContactForm-module--button--DnV-I";
export var errorText = "ContactForm-module--error-text--2gppK";